import { ArrowRight, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';
import { trackPhoneClick, trackCTAClick } from '../lib/analytics';

export const CTABanner = ({ titleKey, subtitleKey }) => {
  const { t } = useLanguage();
  const title = titleKey || t.ctaBanner.title;
  const subtitle = subtitleKey || t.ctaBanner.subtitle;

  return (
    <section className="py-20 bg-gradient-to-r from-[#D4AF37]/10 via-[#8F6B1F]/5 to-[#D4AF37]/10 border-y border-[#D4AF37]/20" data-testid="cta-banner">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{title}</h2>
        <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">{subtitle}</p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link to="/kontakt" onClick={() => trackCTAClick('kontakt_button', 'cta_banner')}>
            <Button size="lg" data-testid="cta-contact-btn" className="bg-gradient-to-r from-[#F1D27A] via-[#D4AF37] to-[#8F6B1F] hover:from-[#D4AF37] hover:to-[#8F6B1F] text-black font-bold px-8 py-6 text-base rounded-lg transition-all duration-300 hover:scale-105 shadow-lg shadow-[#D4AF37]/30">
              {t.ctaBanner.btn}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
          <a href="tel:+491631945793" onClick={() => trackPhoneClick()}>
            <Button size="lg" variant="outline" data-testid="cta-call-btn" className="border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black font-bold px-8 py-6 text-base rounded-lg transition-all duration-300 hover:scale-105">
              <Phone className="mr-2 w-5 h-5" />
              +49 163 1945793
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
